var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsPauseRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.333 155.958C126.819 155.958 122.955 154.352 119.743 151.14C116.531 147.928 114.922 144.062 114.917 139.542V57.4582C114.917 52.9436 116.525 49.0802 119.743 45.868C122.961 42.6558 126.824 41.047 131.333 41.0415C135.842 41.036 139.709 42.6449 142.932 45.868C146.155 49.0912 147.761 52.9545 147.75 57.4582V139.542C147.75 144.056 146.144 147.922 142.932 151.14C139.72 154.358 135.853 155.964 131.333 155.958ZM65.6667 155.958C61.1521 155.958 57.2887 154.352 54.0765 151.14C50.8643 147.928 49.2555 144.062 49.25 139.542V57.4582C49.25 52.9436 50.8588 49.0802 54.0765 45.868C57.2942 42.6558 61.1576 41.047 65.6667 41.0415C70.1758 41.036 74.0419 42.6449 77.265 45.868C80.4882 49.0912 82.0943 52.9545 82.0833 57.4582V139.542C82.0833 144.056 80.4772 147.922 77.265 151.14C74.0528 154.358 70.1867 155.964 65.6667 155.958Z",
    fill: "#f7f7f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsPauseRounded);
export default __webpack_public_path__ + "static/media/material-symbols_pause-rounded.0606699e7869801f128b0306cbbe8877.svg";
export { ForwardRef as ReactComponent };